<template>
  <div class="product-item" v-if="product">
    <div class="row">
      <div class="col-md-5 col-lg-6 product-item-gallery">
        <Gallery :photos="product.images" v-on:selectedImg="select"></Gallery>
      </div>
      <div class="col-md-7 col-lg-6 product-item-name">
        <h2 class="product-name text-info">{{product.name}}</h2>
        <div class="row">
          <div class="col-6 text-secondary">Producent:</div>
          <div class="col-6 text-info">
            <span>{{product.producer}}</span>
          </div>
        </div>
        <!-- <div class="row">
          <div class="col-6 product-code">
            Symbol producenta:
          </div>
          <span class="col-6">{{product.code}}</span>
        </div>-->
        <div
          v-if="(product.stock > 0 || purchaseOverbookedProducts) && !demo"
          class="product-item-price"
        >
          <!-- <div class="row">
            <div class="col-6">Stan magazynowy</div>
            <div class="col-6 stock">
              <span>{{product.stock>50 ? 'powyżej '+50 : product.stock}} {{product.unit}}</span>
            </div>
          </div>-->
          <div class="row">
            <!-- <div class="col-6">{{product.clientPrice.toFixed(2)}} {{priceToString(product.netPrice, currency().currency.symbol)}}</div> -->

            <div class="col-6">
              <div
                class="price-type text-secondary"
                v-if="userSettings.B2B_CLIENT_PRICE_TYPE == 'net'"
              >cena netto</div>
              <div class="price-type text-secondary" v-else>cena brutto</div>
            </div>
            <div class="col-6">
              <div
                class="text-info"
              >{{ calculateClientPrice(product.clientPrice, product.tax, 'net', userSettings, currency()) }}</div>
            </div>
          </div>
          <!-- <div v-if="discountPrice(product) > 0 || purchaseOverbookedProducts" class="row">
            <div class="col-6" v-if="userSettings.B2B_CLIENT_PRICE_TYPE == 'net'">Cena klienta netto</div>
            <div class="col-6 client-price" v-else>Cena klienta brutto</div>
            <div class="col-6">{{product.clientPrice.toFixed(2)}} {{currency().currency.symbol}}</div>
          </div>-->
          <div class="row">
            <div class="col-6 text-secondary">cena brutto</div>
            <div
              class="col-6 text-info"
            >{{String(calculateGrossPrice(product.clientPrice, product.tax).toFixed(2)).replace('.',',')}} {{currency().currency.symbol}}</div>
          </div>
          <div class="row">
            <div class="col-6 text-secondary">Rabat</div>
            <div class="discount col-6">
              <span class="text-info">{{discountPrice(product)}}%</span>
            </div>
          </div>

          <div class="row">
            <div class="col-12 my-2">
              <ul v-if="product.gratis.length > 0" class="product-item-gratis alert alert-info">
                Przy zakupie:
                <li class="product-item-gratis-info" v-for="gratis in product.gratis">
                  <span>{{gratis.Rangefrom}} - {{gratis.Rangeto}}</span>
                  sztuk otrzymujesz
                  <span>{{gratis.Gratiscount}}x gratis</span>
                </li>
              </ul>
            </div>
          </div>

          <div class="col-12" v-if="!demo">
            <div class="row">
              <span class="avalibilty-text text-secondary text-uppercase">Dostępność:</span>
            </div>
            <div class="row basket-button px-0">
              <AccessibilityIndicator :product_stock="product.stock"></AccessibilityIndicator>
              <div class="input-group mb-3 quantity-input ml-auto">
                <div class="input-group-prepend" @click="subQuantity()">
                  <span class="input-group-text" id="basic-addon1">-</span>
                </div>
                <input
                  type="text"
                  class="form-control"
                  id="quantity-input"
                  :value="quantity"
                  @keyup="changeQuantity($event, product)"
                />
                <div class="input-group-append" @click="addQuantity()">
                  <span class="input-group-text">+</span>
                </div>
              </div>

              <button
                type="button"
                class="btn btn-info"
                @click="addToBasket(product)"
              >Dodaj do koszyka</button>
            </div>
            <div class="row offer-button px-0">
              <button
                v-if="offerEnable"
                type="button"
                class="btn btn-dark"
                @click="addToOffer(product)"
              >Dodaj do oferty</button>
            </div>
          </div>
        </div>
        <div v-else>
          <button type="button" class="btn btn-success">SKONTAKTUJ SIĘ Z NAMI!</button>
        </div>

        <div class="col-12 product-short-description" v-html="shortDescription"></div>
      </div>
    </div>
    <div class="col-12 product-details">
      <Tabs :productId="id" :attachments="product.attachment" :attributes="attributes" />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import CalculatePrice from "../product/CalculatePrice";
import Product from "../product/Product";
import Gallery from "./elements/Gallery.vue";
import Tabs from "./elements/Tabs.vue";
import slider from "vue-image-scroll";
import AccessibilityIndicator from "./AccessibilityIndicator.vue";

export default {
  components: { Gallery, Tabs, slider, AccessibilityIndicator },
  computed: {
    ...mapState({
      search: state => state.search,
      userSettings: state => state.user.userSettings,
      category: state => state.categories,
      shop: state => state.shop,
      demo: state => state.demo.enabled,
      prices: state => state.user.userPrices
    }),
    ...mapGetters({
      currency: "company/selectedCurrency"
    })
  },
  data() {
    return {
      enter: false,
      quantity: 1,
      product: null,
      attributes: [],
      shortDescription: "",
      units: { single: [], decimals: [] },
      showModal: false,
      setting: {
        imgSrc: []
      },
      selectedImage: "",
      myCroppa: {},
      purchaseOverbookedProducts: false,
      offerEnable: false
    };
  },

  props: ["id", "slug"],
  methods: {
    ...CalculatePrice(),
    async addToOffer(product) {
      this.$store.dispatch("offer/add", {
        productId: product.id,
        variantId: product.variantId
      });
      this.$store.dispatch("openRightWindowOffer");
    },
    moveImage(event) {
      // let posX = event.clientX;
      // let posY = event.clientY;
      let im = document.getElementById("image-big");
      im.innerHTML = `
      <img class="sm-img" id="sm-im" src="${this.selectedImage}"/>
      `;
      let posX = event.clientX ? event.clientX : event.pageX - img.offsetLeft;
      let posY = event.clientY ? event.clientY : event.pageY - img.offsetTop;
      // im.
      document.getElementById("sm-im").style.backgroundPosition =
        -posX * 4 + "px " + -posY * 4 + "px";
    },
    select(a) {
      this.selectedImage = a;
    },
    getProducerLink() {
      return (
        "https://plimg.redbay.pl/producer/" +
        this.search.product.producerId +
        ".jpg"
      );
    },

    discountPrice(product) {
      let client = this.calculateClientPriceValue(
        product.clientPrice,
        product.tax,
        "net",
        this.userSettings,
        this.currency()
      );
      let net = this.calculateClientPriceValue(
        product.netPrice,
        product.tax,
        "net",
        this.userSettings,
        this.currency()
      );
      return net > 0 ? Math.round((1 - client / net) * 100) : 0;
    },

    getLevelLink() {
      return (
        "http://sample.redbay.pl/grafika/opony/tirelabel.php?ep=" +
        this.search.product.energy +
        "&dh=" +
        this.search.product.adhesion +
        "&fa=" +
        this.search.product.noiseLevel +
        "&kh=" +
        this.search.product.noiseClass
      );
    },

    subQuantity() {
      if (this.quantity > 0) {
        if (this.units.single.indexOf(this.product.unit) >= 0) {
          this.quantity--;
        } else if (this.units.decimals.indexOf(this.product.unit) >= 0) {
          this.quantity = Math.round((this.quantity - 0.001) * 1000) / 1000;
        } else {
          this.quantity--;
        }
      }
    },

    addQuantity() {
      if (this.quantity < this.product.stock) {
        if (this.units.single.indexOf(this.product.unit) >= 0) {
          this.quantity++;
        } else if (this.units.decimals.indexOf(this.product.unit) >= 0) {
          this.quantity = Math.round((this.quantity + 0.001) * 1000) / 1000;
        } else {
          this.quantity++;
        }
      }
    },

    changeQuantity(ev, product) {
      let value = document.getElementById("quantity-input").value;

      if (value < product.stock) {
        this.quantity = value;
      } else {
        this.quantity = product.stock;
        document.getElementById("quantity-input").value = product.stock;
      }
    },

    async addToBasket(product) {
      if (this.quantity > 0) {
        await this.$store.dispatch("basket/addToBasket", {
          id: product.variantId,
          cart_quantity: this.quantity
        });
      }
      this.$store.dispatch("openRightWindow");
    },
    filter(val) {
      if (val == "SYMBOL_TOWARU" || val == "IDP_TOWARU") {
        return "";
      } else if (val == "SYMBOL_PRODUCENTA") {
        return "Symbol Producenta";
      } else if (val == "IDP_WZORCA") {
        return "Wzorzec";
      }
    }
  },
  async beforeMount() {
    this.offerEnable = this.$config.get("offer.enable");
    if (!this.$store.state.user.authorizedUser) {
      this.$router.replace({ name: "mainPage" });
    }
    if (!this.demo) {
      await this.$store.dispatch("user/getUserSettings");
    }
    let group = this.userSettings["USER_GROUP"]
      ? this.userSettings["USER_GROUP"]
      : 0;
    let visibleAttributes = this.$config.get("productPage.visibleAttributes");
    let response = await this.$store.dispatch("search/findProduct", {
      id: this.id,
      filters: this.$config.get("searchPage.filters")
    });
    this.product = Product.buildProductView(
      response.documentList[0],
      this.prices,
      group,
      this.search.department
    );
    this.setting.imgSrc = this.product.images;
    this.selectedImage = this.product.images[0].view;
    this.$store.dispatch(
      "brands/setFilters",
      Product.buildFilter(response, "Producer")
    );
    this.$store.dispatch(
      "categories/setFilters",
      Product.buildFilter(response, "Category")
    );
    this.$store.dispatch(
      "search/setBuiltFilters",
      this.$config
        .get("searchPage.filters")
        .attributes.map(f =>
          Object.create({
            name: f.name,
            values: Product.buildFilter(response, f.name)
          })
        )
        .filter(f => f.values.length > 0)
    );

    this.attributes = visibleAttributes
      .map(name =>
        this.product.attributes.find(
          attr => attr.AttributeProperty.Name == name
        )
      )
      .filter(att => att != null);

    this.$store.state.breadcrumbPath = [
      { title: "Szukaj", route: "/search" },
      { title: this.product.name, route: null }
    ];
    let description = await this.$store.dispatch("search/description", this.id);
    this.description = description.description;
    let short = await this.$store.dispatch("search/shortDescription", this.id);
    this.shortDescription = short.description;
    this.$store.commit("categories/selectedProduct", this.product.categories);

    const plugin = document.createElement("script");
    plugin.setAttribute(
      "src",
      "//cdn.rawgit.com/asvd/dragscroll/master/dragscroll.js"
    );
    plugin.async = true;
    document.head.appendChild(plugin);
    let b2bOverbooking = this.shop.settings.find(
      s => s.name == "B2B_OVERBOOKING"
    );
    this.purchaseOverbookedProducts =
      b2bOverbooking && b2bOverbooking.value == 1;
  }
};
</script>
<style>
.input-group-text {
  cursor: crosshair;
}
</style>



// WEBPACK FOOTER //
// src/components/products/src/productPage/Standard.vue